<template>
    <div class="pause modal-2" v-show='getModalCadastro' >
        <div class="modal-content-my">
            <form class='form-modal' id="form-cadastro" @submit.prevent='saveAttendance' autocomplete="off">
                <div class="modal-header">
                    <h3 class="title-text">Cadastro de atendimento</h3>
                    <span @click='btnClose' class='closeBtn'>&times;</span>
                </div>
                <div class="modal-body">
                    <h5 class="title-text">Dados Pessoais</h5>

                    <div class="row mt-6">
                        <div class="col-8">
                            <label for="nome">Nome</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="nome" name="name" class="form-control" required aria-label="nome" aria-describedby="nome">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="rg">RG</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="rg" name="rg" class="form-control" :required="cobertura != 0" aria-label="rg" aria-describedby="rg">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-6">
						<div class="col-4">
                            <label for="cpf">CPF</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="cpf" name="cpf" class="form-control" :required="cobertura != 0" aria-label="cpf" aria-describedby="cpf">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="nasc">Data de Nascimento</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="date" id="nasc" name="birthday" class="form-control" :required="cobertura != 0" aria-label="nasc" aria-describedby="nasc">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="email">E-mail</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="email" name="email" class="form-control" :required="cobertura != 0" aria-label="email" aria-describedby="email">
                            </div>
                        </div>
                    </div>

					<div class="row mt-6">
						<div class="col-4">
                            <label for="telefone">Telefone (1)</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="telefone" name="phone" class="form-control" required aria-label="telefone" aria-describedby="telefone">
                            </div>
                        </div>

						<div class="col-4">
                            <label for="telefone">Telefone (2)</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="telefone-2" name="phone_2" class="form-control"  aria-label="telefone" aria-describedby="telefone">
                            </div>
                        </div>
					</div>

                    <br>

                    <h5 class="title-text">Endereço</h5>
                    <div class="row mt-6">
                        <div class="col-4">
                            <label for="cep">CEP</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="cep" name="cep" class="form-control" required aria-label="cep" aria-describedby="cep">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="rua">Rua</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="rua" name="street" class="form-control" :required="cobertura != 0" aria-label="rua" aria-describedby="rua">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="bairro">Bairro</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="bairro" name="neighborhood" class="form-control" :required="cobertura != 0" aria-label="bairro" aria-describedby="bairro">
                            </div>
                        </div>

                    </div>

                    <div class="row mt-6">
                        <div class="col-4">
                            <label for="cidade">Cidade</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="cidade" name="city" class="form-control" :required="cobertura != 0" aria-label="cidade" aria-describedby="cidade">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="numero">Número</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="numero" name="number" class="form-control" :required="cobertura != 0" aria-label="numero" aria-describedby="numero">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="complemento">Complemento</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="complemento" name="complement" :required="cobertura != 0" class="form-control" aria-label="complemento" aria-describedby="complemento">
                            </div>
                        </div>

                    </div>

                    <div class="row mt-6">

                        <div class="col-4">
                            <label for="referencia">Ponto de Referencia</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="referencia" name="reference" class="form-control" aria-label="referencia" aria-describedby="referencia">
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="coverage_area">Possui Área de Cobertura ?</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <select id="coverage_area" v-model="cobertura" name="coverage_area" class="form-control" aria-label="coverage_area" aria-describedby="coverage_area" :required="cobertura != 0">
                                    <option value="" selected disabled>Selecione uma Opção {{ cobertura }}</option>
                                    <option value="1">Sim</option>
                                    <option value="0">Não</option>
                                </select>
                            </div>
                        </div>

                    </div>

                    <br>

                    <h5 class="title-text">Plano</h5>
                    <div class="row mt-6">
                        <div class="col-9">
                            <label for="plano">Qual Plano</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>

                                <select class="select2-multi filho form-control" :required="cobertura != 0" name="type_plan">
                                    <option value="null" selected>Nenhum Plano Selecionado</option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <br>

                    <div class="row mt-6">
                        <div class="col-4">
                            <label for="linha_telefonica">Quer linha telefonica</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <select id="linha_telefonica" name="accept_line_phone" class="form-control" :required="cobertura != 0" aria-label="linha_telefonica" aria-describedby="linha_telefonica" >
                                    <option value="1">Sim</option>
                                    <option value="0" selected>Não</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="valor">Valor do plano</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input :value="this.valor" type="text" id="valor" :required="cobertura != 0" name="value_plan" class="form-control" aria-label="valor" aria-describedby="valor" readonly>
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="promocao">Promoção</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input :value="this.promocao" type="text" id="promocao" name="promotion" class="form-control" :required="cobertura != 0" aria-label="promocao" aria-describedby="promocao" readonly>
                            </div>
                        </div>

                    </div>
                    <br>

                    <div class="row mt-6">
                        <div class="col-4">
                            <label for="ponto_adicional">Ponto Adicional</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input value="0" type="number" id="ponto_adicional" name="additional_point" required class="form-control" aria-label="ponto_adicional" aria-describedby="ponto_adicional" >
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="outra_operadora">Possui outra operadora</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <select id="outra_operadora" name="another_operator" class="form-control" aria-label="outra_operadora" aria-describedby="outra_operadora" >
                                    <option value="1">Sim</option>
                                    <option value="0" selected>Não</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-4">
                            <label for="qual_operadora">Qual Operadora</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <input type="text" id="qual_operadora" name="type_operator" class="form-control" aria-label="qual_operadora" aria-describedby="qual_operadora">
                            </div>
                        </div>

                    </div>

                    <br>

                    <div class="row mt-6">
                        <div class="col-4">
                            <label for="installation_period">Preferência de instalação</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-user fa-fw"></i></span>
                                </div>
                                <select id="installation_period" name="installation_period" class="form-control" aria-label="installation_period" aria-describedby="installation_period" :required="cobertura != 0">
                                    <option value="" selected disabled>Selecione um período</option>
                                    <option value="1">Manhã</option>
                                    <option value="0">Tarde</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <br>
                    <div class="modal-footer ">
                        <button type="submit" id="idButtom" class="btn btn-success">Cadastrar</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click='btnClose'>Cancelar</button>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import select2 from 'select2';
import $ from 'jquery';
export default {
    data(){
        return {
            valor: '',
            promocao: '',
            cobertura: ''

        }
    },
    computed:{
        ...mapGetters(['getModalCadastro','getId','getExtension','getPlans'])
    },
    methods:{
        ...mapActions(['setModalCadastro','searchPlan','saveCadastro']),
        btnClose(event){
            this.setModalCadastro();
        },
        saveAttendance(){
            let form = document.querySelector("#form-cadastro");
            let formulario = new FormData(form);
            this.saveCadastro(formulario);
            $(".select2-multi").val('null').trigger('change');
        }
    },
    created(){
        self = this;

        //BUSCANDO OS PLANOS E PREENCHENDO NO INPUT AS OPTIONS
            this.searchPlan().finally(function(response){
                for(var i=0;self.getPlans.length > i;i++){
                    var plano = self.getPlans[i]["plano"];
                    var valor = self.getPlans[i]["valor"];
                    var promocao = self.getPlans[i]["promocao"];

                    let html = '';
                    html += `<option value="${plano}" promocao="${promocao}" valor="${valor}" >${plano}</option>`
                    $('.select2-multi').append(html);
                }

                $(".select2-multi").select2();

                $('.select2-multi').change(function() {
                    self.valor = $(this).find(':selected').attr('valor');
                    self.promocao = $(this).find(':selected').attr('promocao');
                });
            });

        document?.addEventListener("keydown", function(event){
            if(event.ctrlKey && event.key == "Enter"){
                self.setModalCadastro();
            }
        });
    },
    mounted() {
        self = this;

        //PESQUISANDO O CEP E PREENCHENDO OS DADOS AUTOMATICAMENTE
            $("#cep").blur(function() {
                var cep = $(this).val().replace(/\D/g, '');
                if (cep != "" && cep.length == 8) {
                    var validacep = /^[0-9]{8}$/;
                    if (validacep.test(cep)) {
                        $("#rua").val("...");
                        $("#bairro").val("...");
                        $("#cidade").val("...");

                        $.getJSON("https://viacep.com.br/ws/" + cep + "/json/?callback=?", function(dados) {
                            if (!("erro" in dados)) {
                                $("#rua").val(dados.logradouro);
                                $("#bairro").val(dados.bairro);
                                $("#cidade").val(dados.localidade);
                            } else {
                                $("#rua").val('');
                                $("#bairro").val('');
                                $("#cidade").val('');
                            }
                        });
                    }
                } else {
                    $("#rua").val('');
                    $("#bairro").val('');
                    $("#cidade").val('');
                }
            });
    }
}
</script>

<style>
    .select2-container {
        min-width: 200px;
    }
</style>
<style scoped>
    .modal-content-my{
        max-width: 900px;
    }

    .modal-2{
        z-index: 2;
    }
</style>
